module.exports = __webpack_public_path__ + "static/media/desktopScreenshot01.e63152fb.jpg";